import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { ScrollContext } from 'react-router-scroll-4';
import './index.scss';
import { DataToken } from '../src/function/Format';

// ** Import custom components **
import store from './store';
import App from './components/app';

// Dashboards
import Default from './components/dashboard/default/index_component';

// Pages
import Error404 from './components/fitur/error-404';
import Login from './components/fitur/login';

// Data Master
import JenisAplikasi from './components/master/jenis-aplikasi';
import JenisAplikasiPerangkat from './components/master/jenis-aplikasi-perangkat';
import JenisSurat from './components/master/jenis-surat';
import VersionApp from './components/master/version-app';
// End Data Master

// Konfigurasi
import KonfigurasiAlamat from './components/konfigurasi/konfigurasi-alamat';
import KonfigurasiDesa from './components/konfigurasi/konfigurasi-desa';
// End Konfigurasi

// Request Surat
import RequestSurat from './components/request-surat/request-surat';
// End Request Surat

// Invoice Pembelian
import InvoicePembelian from './components/invoice-pembelian/invoice-pembelian';
import DetailInvoicePembelian from './components/invoice-pembelian/detail-invoice-pembelian';
// End Invoice Pembelian

// Data Master
import Bumdes from './components/landing-digidesa/data-bumdes';
import Partner from './components/landing-digidesa/data-partner';
import DaftarDesa from './components/landing-digidesa/daftar-desa';
import DataKlik from './components/landing-digidesa/data-klik';
// End Data Master

const PublicRoute = ({ component: Component, ...rest }) => (
	<Route
		{...rest}
		render={(props) =>
			localStorage.getItem('access_token') ? (
				<Redirect
					to={{
						pathname: '/dashboard',
						state: { from: props.location }
					}}
				/>
			) : (
					<Component {...props} /> // apa maksudnya ... props ?
				)}
	/>
);

const PrivateRoute = ({ component: Component, ...rest }) => (
	<Route
		{...rest}
		render={(props) =>
			localStorage.getItem('access_token') ? (
				<Component {...props} />
			) : (
					<Redirect
						to={{
							pathname: '/',
							state: { from: props.location }
						}}
					/>
				)}
	/>
);

// Route Admin Bisnis
const AdminBisnis = ({ component: Component, ...rest }) => (
	<Route
		{...rest}
		render={props => {
			if (localStorage.getItem("access_token")) {
				let token = DataToken(localStorage.getItem("access_token"));
				if (token.sub.data_role.nama !== "Admin Tim Bisnis") {
					return (
						<Redirect
							to={{
							pathname: "/login",
							state: { from: props.location }
							}}
						/>
					);
				} else {
					return <Component {...props} />;
				}
			} else {
				return (
						<Redirect
						to={{
							pathname: "/login",
							state: { from: props.location }
						}}
					/>
				);
			}
		}}
	/>
);

// Route Admin Bisnis
const Admin = ({ component: Component, ...rest }) => (
	<Route
		{...rest}
		render={props => {
			if (localStorage.getItem("access_token")) {
				let token = DataToken(localStorage.getItem("access_token"));
				if (token.sub.data_role.nama !== "Admin") {
					return (
						<Redirect
							to={{
							pathname: "/login",
							state: { from: props.location }
							}}
						/>
					);
				} else {
					return <Component {...props} />;
				}
			} else {
				return (
						<Redirect
						to={{
							pathname: "/login",
							state: { from: props.location }
						}}
					/>
				);
			}
		}}
	/>
);

class Root extends React.Component {
	render() {
		return (
			<Provider store={store}>
				<BrowserRouter basename={'/'}>
					<ScrollContext>
						<Switch>
							<PublicRoute exact path={`${process.env.PUBLIC_URL}/`} component={Login} />

							<Route path={`${process.env.PUBLIC_URL}/pages/error-404`} component={Error404} />

							<App>
								<PrivateRoute path={`${process.env.PUBLIC_URL}/dashboard`} component={Default} />

								{/* Data Master */}
								<Admin path={`${process.env.PUBLIC_URL}/main/jenis-aplikasi`} component={JenisAplikasi} />
								<Admin path={`${process.env.PUBLIC_URL}/main/jenis-aplikasi-perangkat`} component={JenisAplikasiPerangkat} />
								<Admin path={`${process.env.PUBLIC_URL}/main/jenis-surat`} component={JenisSurat} />
								<Admin path={`${process.env.PUBLIC_URL}/main/version-app`} component={VersionApp} />
								{/* End Data Master */}
						
								{/* Konfigurasi */}
								<Admin path={`${process.env.PUBLIC_URL}/main/konfigurasi-alamat`} component={KonfigurasiAlamat} />
								<Admin path={`${process.env.PUBLIC_URL}/main/konfigurasi-desa`} component={KonfigurasiDesa} />
								{/* End Konfigurasi */}
								
								{/* Request Surat */}
								<PrivateRoute path={`${process.env.PUBLIC_URL}/main/request-surat`} component={RequestSurat} />
								{/* End Request Surat */}

								{/* Invoice Pembelian */}
								<Admin path={`${process.env.PUBLIC_URL}/main/invoice-pembelian`} component={InvoicePembelian} />
								{/* End Invoice Pembelian */}

								{/* Data Landing Digidesa */}
								<PrivateRoute path={`${process.env.PUBLIC_URL}/main/bumdes`} component={Bumdes} />
								<PrivateRoute path={`${process.env.PUBLIC_URL}/main/partner`} component={Partner} />
								<PrivateRoute path={`${process.env.PUBLIC_URL}/main/daftar-desa`} component={DaftarDesa} />
								<PrivateRoute path={`${process.env.PUBLIC_URL}/main/data-klik`} component={DataKlik} />
								{/* End Data Landing Digidesa */}


								{/* Admin Bisnis */}
								<AdminBisnis path={`${process.env.PUBLIC_URL}/main/list-desa`} component={KonfigurasiDesa} />
								<AdminBisnis path={`${process.env.PUBLIC_URL}/main/list-desa?sort=asc`} component={KonfigurasiDesa} />
								<AdminBisnis path={`${process.env.PUBLIC_URL}/main/list-invoice-pembelian`} component={InvoicePembelian} />
								<AdminBisnis path={`${process.env.PUBLIC_URL}/main/detail-invoice-pembelian`} component={DetailInvoicePembelian} />
							</App>
						</Switch>
					</ScrollContext>
				</BrowserRouter>
			</Provider>
		);
	}
}

ReactDOM.render(<Root />, document.getElementById('root'));
